import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-navy-200 bg-white" data-id="element-35" data-mp="32wd2qgad7ltj">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 px-4 py-8 text-sm text-navy-600 sm:flex-row sm:items-center sm:justify-between sm:px-6" data-id="element-36" data-mp="3gfitaf6445cj">
        <p className="font-display font-bold uppercase tracking-wide text-navy-950" data-id="element-37" data-mp="32lrn9grlb3lk">
          Dominio del Pickleball
        </p>
        <p data-id="element-38" data-mp="3ufa6wespvjq0">© {new Date().getFullYear()} · Producto digital. Todos los derechos reservados.</p>
      </div>
    </footer>;
}